import { render, staticRenderFns } from "./historicoPagamento.vue?vue&type=template&id=0ef2b460&"
import script from "./historicoPagamento.vue?vue&type=script&lang=js&"
export * from "./historicoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports